'use client';
import { createAnalyticsContext } from '@s7/base';

var Event;
(function(Event) {
    Event["CLICK_CTA"] = "click_cta";
    Event["SEARCH"] = "search";
    Event["SUBMIT_SUCCESS"] = "submit_success";
    Event["EVENT_ERROR"] = "event_error";
})(Event || (Event = {}));
const topics = {
    footer: [
        {
            step: 'footer'
        },
        {
            clickMenu: (name)=>[
                    "click_cta",
                    {
                        item_category: 'menu',
                        item_name: name
                    }
                ],
            clickSecondaryLink: (name)=>[
                    "click_cta",
                    {
                        item_category: 'secondary_links',
                        item_name: name,
                        ux_ui: 'button'
                    }
                ],
            clickSearch: (name)=>[
                    "click_cta",
                    {
                        item_category: 'search',
                        item_name: name
                    }
                ],
            clickCallCenter: (name, uiUx)=>[
                    "click_cta",
                    {
                        item_category: 'call_center',
                        item_name: name,
                        ux_ui: uiUx
                    }
                ],
            clickDownloadApp: (name)=>[
                    "click_cta",
                    {
                        item_category: 'download_app',
                        item_name: name
                    }
                ],
            clickSocialMedia: (name)=>[
                    "click_cta",
                    {
                        item_category: 'social_media',
                        item_name: name
                    }
                ],
            search: (term, quantity)=>[
                    "search",
                    {
                        item_category: 'search',
                        search_term: term,
                        quantity
                    }
                ],
            submitSuccess: ()=>[
                    "submit_success",
                    {
                        item_category: 'subscribe',
                        result: 'subscribe_to_news'
                    }
                ],
            eventError: (type, errorId, errorMessage)=>[
                    "event_error",
                    {
                        item_category: 'subscribe',
                        error: 'submit_success',
                        result: 'subscribe_to_news',
                        type,
                        error_code: `code:${errorId};text:${errorMessage}`
                    }
                ]
        }
    ]
};
const [AnalyticsProvider, useAnalytics] = createAnalyticsContext(topics);

export { AnalyticsProvider, useAnalytics };
//# sourceMappingURL=analytics.js.map
